import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicDejDeluxe from "../Components/ProjPicDejDeluxe";

const ProjectPageDejDeluxe = () => {
    return (
        <>
            <Navbar />
            <ProjPicDejDeluxe />
            <Footer />
        </>
    );
};

export default ProjectPageDejDeluxe;
